module.exports = __webpack_public_path__ + "static/media/daniel-olahh.facbbdb7.jpg";